<script setup lang="ts">
import { useVModel } from '@vueuse/core';

import RadioList from './radio-list.vue';
import RadioListSearch from './radio-list-search.vue';

const props = defineProps<{
    search?: string;
}>();
const emit = defineEmits<{
    (event: 'update:search', value: string): void;
}>();
const searchQuery = useVModel(props, 'search', emit, { passive: true });

</script>
<script lang="ts">
export default {
    inheritAttrs: false,
};
</script>
<template>
    <RadioListSearch v-model:search="searchQuery" />
    <RadioList v-bind="$attrs" :search="searchQuery">
        <template #buttons="{ option }">
            <slot name="buttons" :option="option" />
        </template>
    </RadioList>
</template>
